import { ServerLists } from "../StaticData";
import Api from "../state/Api"
import { QuotationValidationStore } from "../state/validation-stores"
import { AIR, FFF, LCL, SPOTOCEAN } from "../static-data/visibilityrules";
import pdfIcon from "../assets/images/pdfIcon.svg";
import excelIcon from "../assets/images/excelIcon.svg";
import imageIcon from "../assets/images/imageIcon.svg";
import wordIcon from "../assets/images/word.svg";
import { enquiryStore } from "../enquiry/enquiry-data";
import { ABNORMAL_COUNTRY_NAMES, PERMISSIONS_NEW } from "./constants";
import { Country } from "country-state-city";
import { CargoDetails } from "../QuotationData";
import { lclWeightForPort, maxWeightPerContainerFcl } from "../StaticData";
import { BreadCrumb } from "../mui-components/BreadCrumbComponent";
import MyactionUtils from "../my-actions/Myactionutils";
import { bookingsStore, breadCrumbStore, contractsStore, filtersState, newDashboardState } from "../state/CommonState";
import airlineCodes from "../static-data/airlines";
import RoleUtils from "./RoleUtils";
import { cloneDeep } from "lodash";
let timer
const CREDIT_AMOUNT_LOWER_THRESHOLD = 2000000;
const CREDIT_AMOUNT_UPPER_THRESHOLD = 25000000;
const CREDIT_DAYS_LOWER_THRESHOLD = 30;
const CREDIT_DAYS_UPPER_THRESHOLD = 90;
export default class Utils {

    static getYearDayMonth(inputDate){
        var parts = inputDate.split('-');
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10) - 1;
        var year = parseInt(parts[2], 10);
        return new Date(year, month, day);
    }
    static timeAgo(epochTime) {
        if (epochTime.toString().length === 10) {
            epochTime *= 1000;
        }

        const now = Date.now();
        const diffMs = now - epochTime;

        const seconds = Math.floor(diffMs / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        if (seconds < 60) return `${seconds} seconds ago`;
        if (minutes < 60) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
        if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
        return `${days} day${days > 1 ? 's' : ''} ago`;
    }

static formatToDisplay = (val) => {
  // Convert yyyy-mm-dd to dd-mm-yyyy
  if (!val) return "";
  const [year, month, day] = val.split("-");
  return `${day}-${month}-${year}`;
};

static formatToSave = (val) => {
  // Convert dd-mm-yyyy to yyyy-mm-dd
  if (!val) return "";
  const [day, month, year] = val.split("-");
  return `${year}-${month}-${day}`;
};

    static convertEpochDate(inputDate){
        const epochTimestamp = inputDate  || 1626106680;
        const date = new Date(epochTimestamp);
        const normalDate = date.toISOString();
        console.log(normalDate);
        const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'UTC' 
        };
        const formattedDate = date.toLocaleString('en-GB', options);
        console.log(formattedDate);
        return formattedDate
    }
    static convertICEGATEDate(dateString = 10101000,type = 1) {
        const day = dateString.substring(0, 2);
        const month = dateString.substring(2, 4);
        const year = dateString.substring(4, 8);
        const date = new Date(`${year}-${month}-${day}`);
        console.log(date);
        let options 
        if (type == 1) {
             options = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              };
        }
        else if (type == 2) {
             options = {  month: 'short', day: '2-digit' };
        }   
        return type == 1?date.toLocaleDateString('en-GB', options)?.replace(/\//g,'-'):date.toLocaleDateString('en-GB', options)
    }

    static getValueForTheGivenKey(key, obj) {
        if (obj[key] && obj[key].length > 0) {
            return obj[key];
        }
        return
    }

    static isValueExists(values,source){
        return values.some((point) => Utils.getValueForTheGivenKey(point, source))
    }

    static formatDateForMail(dateStr){
        if(!dateStr) return dateStr;
        let arr = dateStr.split('-')
        if(arr.length === 3){
          return arr.reverse().join('-')
        }
        return dateStr
    }

    static paymentValidation(currentPayment,task){
       return( Utils.toNum(currentPayment.transAmount)==0 || currentPayment.transDate.length == 0 || currentPayment.transNum.length == 0 || (task.currencyType !== 'INR' && currentPayment.swiftUpload === "")||
                task.stage === 3&&task.isFullPayment === 'No' && (task.paymentReceived==''||task.paymentReceived==0)||
                task.stage === 3&&task.isFullPayment === 'Yes' && (task["Amount Received"]==''||task["Amount Received"]==0))
    }

   static isValidDate1(stringDate) {
        const regex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(\d{4})$/;
        return regex.test(stringDate);
    }

    static getRule(shipmentType,spot=false){
        const rules = {
            "LCL" : LCL,        
            "FCL (Factory/Factory)" : FFF,
            "FCL (Dock/Factory)":FFF,
            "FCL (Factory/Dock)" : FFF,
            "FCL (Dock/Dock)" : FFF,
            "Air" : AIR
        }

        const spotRules = {
            "LCL" : SPOTOCEAN,        
            "FCL (Factory/Factory)" : SPOTOCEAN,
            "FCL (Dock/Factory)":SPOTOCEAN,
            "FCL (Factory/Dock)" : SPOTOCEAN,
            "FCL (Dock/Dock)" : SPOTOCEAN,
        }
        console.log("the spot rules ",spotRules[shipmentType]);
        if(spot){
            return spotRules[shipmentType];
        }
        return rules[shipmentType];
    }

    static extractCountry(addressString){
            const lowercaseAddress = addressString?.toLowerCase();
            const matchedCountry = ServerLists?.countryList?.find(country => lowercaseAddress?.includes(country?.name?.toLowerCase()));
            if (matchedCountry){
            return matchedCountry?.name
            }else{
                for (const country of ABNORMAL_COUNTRY_NAMES) {
                    for (const possibleCase of country?.possibleCases) {
                        if (lowercaseAddress?.includes(possibleCase?.toLowerCase())) {
                            return country?.name;
                        }
                    }
                }
                return 'Unknown';
            }
    };

    static extractPostalCode(address) {
        // Regular expression to match sequences of 4 to 10 digits, which is a common range for postal codes globally
        const postalCodePattern = /\b\d{4,10}\b/;
        
        // Search for the pattern in the address string
        const match = address?.match(postalCodePattern);
        
        // If a match is found, return it, otherwise return null
        return match ? match[0] : null;
    }

    static extractCodeAndReturnCountry(unloc) {
        const regex = /\(([A-Z0-9]{5})\)/;
        const match = unloc.match(regex);
        const result = match ? match[1].substring(0, 2) : null;
        const EntityCountry = Country.getCountryByCode(result);
        return EntityCountry?.name ? EntityCountry?.name : "Unknown";
    }

    static getBookingsImportAndExportStatus(booking){
        const theOriginCountry = Utils.extractCodeAndReturnCountry(booking?.booking?.contract?.portOfLoading)
        const theDestinationCountry = Utils.extractCodeAndReturnCountry(booking?.booking?.contract?.finalPlaceOfDelivery)
        return {isImport : booking?.booking?.country===theDestinationCountry ,isExport:booking?.booking?.country===theOriginCountry}
    }

    static isMyBooking(bookingEntityId){
        if(bookingEntityId?.length>0 ){
            const user = JSON.parse(localStorage.getItem("ag_userrec"))
            let entities;
            if(user){
               entities = user.companyList;
            }
           return entities?.some(({_id})=>_id===bookingEntityId);
        }
        return false;
    }

    static getLengthOfTheValidValue(key,objs){
        let count = 0;
        console.log("the key is ",key, " ",objs)
        objs?.forEach((obj)=>{
            if(Utils.getValueForTheGivenKey(key,obj)){
    
                count++;
            }
        })
        return count;
    }

    static getChargeListFormatFromBooking(contract,isSpot=false){
        let chargesList = [];

        console.log(" the charge list is ...... ",contract.chargesList," is spot ib ",isSpot)
        console.log(" the consigneechargesList list is ...... ",contract.consigneechargesList)
        if(!isSpot){
            console.log(" it goes here .. . . . . .  ")
            return contract.chargesList;
        }else{
           if(contract){
              if(contract.chargesList?.length>0){
                contract.chargesList.forEach((charge)=>{
                    chargesList.push({...charge,onaccount:"On Your Account"})
                })
              }
              if(contract.consigneechargesList?.length>0){
                contract.consigneechargesList.forEach((charge)=>{
                    chargesList.push({...charge,onaccount:"Consignee's Account"})
                })
              }
              if(contract.shipperchargesList?.length>0){
                contract.shipperchargesList.forEach((charge)=>{
                    chargesList.push({...charge,onaccount:"Shipper's Account"})
                })
              }
           }
        }
        console.log(" the product of charge . . . ",chargesList)
        return chargesList
    }
    
    

    static getTrackerPoints(booking,containerIndex=-1,rules,mode) {
        let trackerGraph = [];
        const getValueForLabel = (actualMilestone,details,index,currentBooking)=>{
            console.log("this is inside the value points ",actualMilestone);
            if(index===0){
               if(actualMilestone.milestoneAchieved ){
                  if(typeof details.actual === "function"){
                    return details.actual(currentBooking,actualMilestone.milestoneAchieved,containerIndex)
                  }else{
                    return currentBooking[details.actual];
                  }
               }else{
                if(typeof details.estimate === "function"){
                    return details.estimate(currentBooking,actualMilestone.milestoneAchieved,containerIndex)
                  }else{
                    return currentBooking[details.estimate];
                  }
               }
            }else if(index===1){
                if(actualMilestone.milestoneAdvanced ){
                    if(typeof details.actual === "function"){
                      return details.actual(currentBooking,actualMilestone.milestoneAdvanced,containerIndex)
                    }else{
                      return currentBooking[details.actual];
                    }
                 }else{
                  if(typeof details.estimate === "function"){
                      return details.estimate(currentBooking,actualMilestone.milestoneAdvanced,containerIndex)
                    }else{
                      return currentBooking[details.estimate];
                    }
                 }
      
            }
        }

        const getCurrentMilestone = (milestone)=>{
            let currentMilestone = { milestone: "", milestoneAchieved: false, carrier:"",isPathCompleted: false, milestoneAdvanced: false, milestoneCompleted: false, estimateDetails: ["N/A", "N/A"], shipmentType: "", dynamicIcon: milestone.dynamicIcon,isPortMilestone:false,vesselName:"",vesselNumber:"" , flightNumber:"",bookingId:booking._id,location:milestone.milestone,containerIndex,milestoneIcon:milestone.milestoneIcon};
                currentMilestone.isPortMilestone = milestone.isPortMilestone;
                currentMilestone["milestone"] = milestone.milestone;
                currentMilestone.shipmentType = mode;
                currentMilestone.carrier = "";
                if(milestone.carrier){
                    currentMilestone.carrier = milestone.carrier(booking,containerIndex)
                }else{
                    currentMilestone.carrier = mode.toLowerCase()==="lcl" ? booking.carrier : booking?.booking?.contract?.carrier ;
                }
               
                const isBookingClosed = booking.status_closed?.toLowerCase() === "y" || booking.booking?.status?.toLowerCase() === "archived";
    
                if(milestone.location ){
                    if(typeof milestone.location === "function"){
                        currentMilestone.location = milestone.location(booking,containerIndex);
                    }else{
                     currentMilestone.location = booking[milestone.location];
                    }
                }
                
                if (milestone.milestoneAchievedBasedOn) {
    
                    if(isBookingClosed){
                        currentMilestone.milestoneAchieved = true;
                    }else if(typeof milestone.milestoneAchievedBasedOn === "function"){
                        currentMilestone.milestoneAchieved = milestone.milestoneAchievedBasedOn(booking,containerIndex)
                        
                    }else{
                        currentMilestone.milestoneAchieved = Utils.isValueExists(milestone.milestoneAchievedBasedOn,booking)
                    }
                    
                }
    
                if (milestone.milestoneAdvancedBasedOn) {
                    if(isBookingClosed){
                        currentMilestone.milestoneAdvanced = true;
                    }else if(typeof milestone.milestoneAdvancedBasedOn === "function"){
                        currentMilestone.milestoneAdvanced = milestone.milestoneAdvancedBasedOn(booking,containerIndex)
                    }else{
                    currentMilestone.milestoneAdvanced = Utils.isValueExists(milestone.milestoneAdvancedBasedOn,booking)
                    }
                }
                let downstreamStatus = !milestone.downStreamMilestone(booking); // This indicates whether this is the last milestone of the path
                currentMilestone.isPathCompleted = downstreamStatus;
    
                /** If this is not the last milestone of the path, we check for the completion of the milestone 
                 * based on some keys that is configured in the rules
                 */
                if (!downstreamStatus) {
                    if(isBookingClosed){
                        currentMilestone.milestoneCompleted = true;
                    }else if(typeof milestone.milestoneCompletedBasedOn === "function"){
                    currentMilestone.milestoneCompleted = milestone.milestoneCompletedBasedOn(booking,containerIndex);
                    }else{
                        currentMilestone.milestoneCompleted =   Utils.isValueExists(milestone.milestoneCompletedBasedOn,booking)
                    }
                }
    
                currentMilestone.estimateDetails = [];
                milestone.milestoneDetails.forEach((estDetail, index) => {
                    let count;
                    let include = true;
                    if(estDetail.include){
                        include = estDetail.include(booking,containerIndex);
                    }
                    if(include || estDetail.isLabel ){
                    if(estDetail.count){
                        let toBeCountedFrom = estDetail.count(booking);
                        let listOfObjs = booking[toBeCountedFrom.parentKey]
                        let theUpdatedCount = Utils.getLengthOfTheValidValue(toBeCountedFrom.childKey,listOfObjs);
                        let totalCount =  0;
                        if(listOfObjs){
                            totalCount = listOfObjs.length;
                        }

                        if(booking.booking?.contract?.multidest?.length>1){
                            for(let i=1;i<=4;i++){
                                let theMultiDestKey = `${toBeCountedFrom.parentKey}${i+1}`;
                                if(!booking[theMultiDestKey]){
                                    break;
                                }
                                theUpdatedCount += Utils.getLengthOfTheValidValue(toBeCountedFrom.childKey,booking[theMultiDestKey]);
                                totalCount += booking[theMultiDestKey].length;
                            }
                        }
                      
                        count = `${theUpdatedCount}/${totalCount}`;
                    }
                    
                    let finalValue =  estDetail.isLabel ? { ...estDetail,count } : 
                    { ...estDetail, value: estDetail.value? estDetail.value : getValueForLabel(currentMilestone,estDetail,index,booking),count};
                    currentMilestone.estimateDetails.push(finalValue);
                }});
    
    if(milestone.isPortMilestone){
        if(mode.toLowerCase()==="air"){
            if(typeof milestone.flightKey === "function"){
                currentMilestone.flightNumber = milestone.flightKey(booking,containerIndex);
        }else{
            currentMilestone.flightNumber = booking[milestone.flightKey]
        }
        }else{
            if(typeof milestone.vesselNameKey === "function"){
                currentMilestone.vesselName = milestone.vesselNameKey(booking,containerIndex)
            }else{
                currentMilestone.vesselName = booking[milestone.vesselNameKey]
            }

            if(typeof milestone.vesselNumberKey === "function"){
            currentMilestone.vesselNumber = milestone.vesselNumberKey(booking,containerIndex);
            }else{
            currentMilestone.vesselNumber = booking[milestone.vesselNumberKey];
            }
        } 
    }

    return currentMilestone;
        }
        if(!mode){
            mode = booking.shipmentType;
        }
        if(!rules){ 
            rules = Utils.getRule(booking.shipmentType)
        }
        rules.forEach((milestone,index) => {
            if (milestone.isMilestoneAddsToThePath(booking)) {
                let currentMilestone; 
                if(milestone.iterable){
                    let allMilestones = [];
                    let i = 1;
                    while(milestone.canIterate(booking,i)){
                        let warehouse = `warehouse_${i}`
                        
                        milestone.milestone = Utils.getcitystate(milestone.canIterate(booking,i));
                        let referFrom = i
                        let nowMilestone = cloneDeep(milestone)
                        console.log(" the milestone is hghvjuge jhhbjhbrc ",milestone)
                        let milestoneAchievedBasedOn = milestone.milestoneAchievedBasedOn(booking,referFrom)
                        let milestoneAdvancedBasedOn = milestone.milestoneAdvancedBasedOn(booking,referFrom)
                        let milestoneCompletedBasedOn = milestone.milestoneCompletedBasedOn(booking,referFrom)
                        nowMilestone.milestoneAchievedBasedOn = ()=>milestoneAchievedBasedOn;
                        nowMilestone.milestoneAdvancedBasedOn = ()=>milestoneAdvancedBasedOn;
                        nowMilestone.milestoneCompletedBasedOn = ()=>milestoneCompletedBasedOn;
                        if(milestone.milestoneDetails.length>0){
                            let actualArrivalValue = milestone.milestoneDetails[0].actual(booking,referFrom)
                            let actualDepartureValue = milestone.milestoneDetails[1].actual(booking,referFrom)
                            // nowMilestone.milestoneDetails[0].actual = ()=>actualArrivalValue;
                            // nowMilestone.milestoneDetails[1].actual = ()=>actualDepartureValue;
console.log(" the actual cfvgbh rytvbuy rdcyfvbgyunh cdrvftbghnjm fbgunhjm ",actualArrivalValue,"   ",actualDepartureValue)
                            nowMilestone.milestoneDetails[0] = {activeLabel:"ATA",value:actualArrivalValue}
                            nowMilestone.milestoneDetails[1] = {activeLabel:"ATD",value:actualDepartureValue}
                        } 
                        
                        allMilestones.push(getCurrentMilestone(nowMilestone));
                        console.log(" all  milestones ",i,"  ",allMilestones)
                        ++i
                    }
                    currentMilestone = allMilestones
                }else{
                  currentMilestone =  [getCurrentMilestone(milestone)];
                }
               
    // if(currentMilestone.milestoneCompleted){
    //     currentMilestone.milestoneAchieved = true;
    //     currentMilestone.milestoneAdvanced = true;
    // }
    
                trackerGraph.push(...currentMilestone);
              
            }
        })
    
        let previousMilestoneAchieved = false;
    for (let index = trackerGraph.length-1; index >= 0 ; index--) {
        if(previousMilestoneAchieved){
            // trackerGraph[index].milestoneAchieved = true;
            // trackerGraph[index].milestoneAdvanced = true;
            trackerGraph[index].milestoneCompleted = true;
        }
          if(trackerGraph[index].milestoneAchieved || trackerGraph[index].milestoneAdvanced || trackerGraph[index].milestoneCompleted){
            previousMilestoneAchieved = true;
          }
    }

   
    
        return trackerGraph;
    }
static getcitystate = (v) =>{
    if(!v) return ""
    v = v.split(', ')
    if(v.length==5){
        let k = []
        k.push(v[2])
        k.push(v[3])
        return k.join(', ')
    }else{
        return v.join(', ')
    }
}

static debouncing(func,limit){
    let timer;
    return function(){
        let context = this;
        let args = arguments;
        if(timer){
            clearTimeout(timer);
        }
        timer = setTimeout(()=>{
            func.apply(context,args);
        },limit)
    }
}

    static throttling(func,limit){
        let flag = true;
        return function(){
            let context = this;
            let args = arguments;
            if(flag){
                func.apply(context,args);
                flag = false;
                setTimeout(()=>{
                    flag = true;
                },limit)
            }
        }
    }
    
    static getFCLAtaatFpod(booking,key="gatein_fpod"){ 
         let dayDiff = booking["containerlist"]?.map((container)=>Utils.getDateDifferenceForProgress(container[key],new Date()));
      
         let maxIndex = 0;
         for(let i = 1;i<dayDiff?.length;i++){
             if(dayDiff[maxIndex]>dayDiff[i]){
                maxIndex = i;
             }
         }
         return booking["containerlist"] && booking["containerlist"][maxIndex][key];
      }

      static getClosestDate(datesArray) {
          return MyactionUtils.getmindate(datesArray)
      } 
      
      

    static getDateDifferenceForProgress(startDate,endDate){
      
       
        let date1 ;
        if(typeof startDate === "string"){
          date1 =  Utils.getYearDayMonth(startDate)
        }else{
            date1  = startDate
        }
        let date2;
        if(typeof endDate === "string"){
            date2 = Utils.getYearDayMonth(endDate);
        }else{
            date2 = endDate;
        }

        let difference_ms = date2 - date1
        
        let difference_days = Math.ceil(difference_ms / (1000 * 60 * 60 * 24));
        return difference_days;
    }

    static formatSpotDate(date){
       let inputDate = new Date(date);
            let day = String(inputDate.getUTCDate()).padStart(2, '0');
            let month = String(inputDate.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth() is zero-based
            let year = inputDate.getUTCFullYear();
            // date = new Date(year, month, day);
            return `${day}-${month}-${year}`
    }

 static checkIsISoString(date){
    if (typeof date !== "string") return false;
  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(date);
 }

 static getRequiredDetailsForGivenShipmentScope(){
     let mode = enquiryStore.current.shipmentType.toLowerCase();
     let requiredDetailsForGivenShipmentScope = [];
     let origin = enquiryStore.current.shipmentScope.split("-")[0].toLowerCase();
     let destination = enquiryStore.current.shipmentScope.split("-")[2].toLowerCase();
     let stuffing = enquiryStore.current.stuffingType.toLowerCase();
     let deStuffing = enquiryStore.current.destuffingType.toLowerCase();
 
  if(mode==="fcl"){
     requiredDetailsForGivenShipmentScope.push("Container Details");
  }
 
     if(mode==="lcl" || mode==="air" || (mode==="fcl" && (origin==="door" && stuffing === "dock" ) || (destination === "door" && deStuffing === "dock" ))){
         requiredDetailsForGivenShipmentScope.push("Cargo Details");
     }
 
     if(enquiryStore.vehicleDetailsNeeded){
         requiredDetailsForGivenShipmentScope.push("Vehicle Details")
     }
 
     return requiredDetailsForGivenShipmentScope;
 }

    static dateConversion(value,include=false){
        const date = new Date(value);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return include ?`${year}-${month}-${day}`:`${day}-${month}-${year}`;
    }

    static formatDateBooking(inputDate, includeDayString = true) {
        if (!inputDate || inputDate.length === 0) {
            return;
        }
    
        // Convert ISO string if detected
        if (Utils.checkIsISoString(inputDate) && !inputDate.includes('T')) {
            inputDate = Utils.formatSpotDate(inputDate);
        }
    
        let date;
    
        // Handle date-time inputs like "2025-02-04T18:18"
        if (inputDate.includes('T')) {
            date = new Date(inputDate);
        } else {
            // If not valid, convert "YYYY-MM-DD" to "DD-MM-YYYY"
            if (!Utils.isValidDate1(inputDate)) {
                let parts = inputDate.split('-');
                let year = parseInt(parts[0], 10);
                let month = parseInt(parts[1], 10) - 1;
                let day = parseInt(parts[2], 10);
                date = new Date(year, month, day);
            } else {
                let parts = inputDate.split('-');
                let day = parseInt(parts[0], 10);
                let month = parseInt(parts[1], 10) - 1;
                let year = parseInt(parts[2], 10);
                date = new Date(year, month, day);
            }
        }
    
        // Day and Month Abbreviations
        let dayAbbreviations = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        let monthAbbreviations = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
        let dayIndex = date.getDay();
        let monthIndex = date.getMonth();
        let dayOfMonth = date.getDate();
        let fullYear = date.getFullYear();
    
        // Extract hours and minutes
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let amPm = hours >= 12 ? 'PM' : 'AM';
        let formattedHours = hours % 12 || 12; // Convert to 12-hour format
    
        
        let timeString = `${formattedHours}:${minutes.toString().padStart(2, '0')} ${amPm}`;
    
        if (includeDayString) {
            return `${dayAbbreviations[dayIndex]}, ${dayOfMonth} ${monthAbbreviations[monthIndex]}'${fullYear} ${inputDate.includes('T') ? timeString : ""}`;
        } else {
            return `${dayOfMonth} ${monthAbbreviations[monthIndex]}'${fullYear} ${inputDate.includes('T') ? timeString : ""}`;
        }
    }

    static isValidValue(val){
        if(val?.length>0){
            return val;
       }
       return;
    }

    static findAndReturnFirstValueMatches(target,keys){
        let n = keys?.length || 0
        for(let i=0;i<n;i++){
           if(Utils.isValidValue(target[keys[i]])) {
              return target[keys[i]];
           } 
        }
    return
}



static getPortLocation(val){
    return val.split(",")[0];
}

   static generateFilterOptions(filtersRules,records){
        let filterOptions = [];
        filtersRules.forEach((filterRule)=>{
            console.log(" the enquiry stotre in ",enquiryStore.current.shipmentType)
            if(filterRule.includeFilter()){
                let filterOption = {title: typeof filterRule.label === "function" ? filterRule.label({shipmentType:enquiryStore.current.shipmentType}) : filterRule.label,options : [],isAccordionView:filterRule.isAccordionView}
                let options =  typeof filterRule.generateOptions === "function" ? filterRule.generateOptions(records) : filterRule.generateOptions ;
                if(options?.length>0){
                    filterOption.options = options;
                    filterOptions.push(filterOption)
                }
            }
        })
        return filterOptions;
   }
    
   

//     static formatDateBooking(inputDate,includeDayString=true) {
//         if(!inputDate || inputDate.length===0){
//             return;
//         }
//         if(Utils.checkIsISoString(inputDate)){
//             inputDate = Utils.formatSpotDate(inputDate);
//         }

//        if(!Utils.isValidDate1(inputDate)){
//         var parts = inputDate.split('-');
//         var year = parseInt(parts[0], 10);
//         var month  = parseInt(parts[1], 10);
//         var day = parseInt(parts[2], 10);
//         inputDate = `${day}-${month}-${year}`
//        }

//         var dayAbbreviations = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
//         var monthAbbreviations = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//         var date;
// //         if(!Utils.isValidDate1(inputDate)){
// //             inputDate = new Date(inputDate);
// //             let day = String(inputDate.getUTCDate()).padStart(2, '0');
// // let month = String(inputDate.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth() is zero-based
// // let year = inputDate.getUTCFullYear();
// // date = new Date(year, month, day);
// //         }else 
//         if(inputDate && inputDate.length>0){
//             var parts = inputDate.split('-');
//             var day = parseInt(parts[0], 10);
//             var month = parseInt(parts[1], 10) - 1;
//             var year = parseInt(parts[2], 10);
//             date = new Date(year, month, day);
//         }
//         console.log("the date is ",date)
//          var dayIndex = date.getDay();
//           var monthIndex = date.getMonth();
//            var dayOfMonth = date.getDate();
//          var fullYear = date.getFullYear();
//          var yearAbbreviation = fullYear.toString();
      
//        if(includeDayString){
//         return `${dayAbbreviations[dayIndex]}, ${dayOfMonth} ${monthAbbreviations[monthIndex]}'${yearAbbreviation}`;
//        }else{
//         return `${dayOfMonth} ${monthAbbreviations[monthIndex]}'${yearAbbreviation}`;
//        }
//     }

    static getCity(place,isDoor){
        if(isDoor){
            // if(place.includes("|")){
            // return place.split("|")[1];
            // }else{
                let values = place.split(",");
                if(values.length>=3){
                    return values[values.length-2];
                }else{
                    return values[values.length-1];
                }
            // }
        }else{
            let values = place?.split(",");
            if(!values){
                return "";
            }
            if(values.length===1){
                return place
            }
            let city = values[0].split("(")[0].trim();
          let country = values[values.length-1].split("(")[0].trim();
            return city
        }

    }

    static getCountry(origin,isCity=false){
        let city;
        let country;
       if(origin.includes(";")){
            let values = origin.split(";");
           if(values.length===1){
                return origin
            }
            city = values[0];
           country = values[values.length-1].split("[")[0].trim();
           if(country.includes(":")){
            country = values[values.length-2].split("[")[0].trim();
            }
       }else if(origin.includes(",")){
            let values = origin.split(",");
            if(values.length===1){
                return origin
            }
            city = values[0].split("(")[0].trim();
            country = values[values.length-1].split("(")[0].trim();
       }else{
            return origin
        }
       if(isCity){
            return city;
        }
        return `${city}, ${country}`
    }

    static getFileNameWithoutExtension(fileName){
        let fileNameWithoutExtension = "";
        if(fileName){
           const dotSeparatedFileName = fileName?.split(".");
           fileNameWithoutExtension = dotSeparatedFileName?.slice(0,dotSeparatedFileName?.length-1).join("");
        }
        return fileNameWithoutExtension;   
    }
    
static getFileExtension(fileName){
    let extension = "";
 if(fileName){
    const dotSeparatedFileName = fileName?.split(".");
    extension = dotSeparatedFileName[dotSeparatedFileName?.length-1];
 }
 return extension;
}

static removeFirstMatch(input) {
  let array = [
    'FDD', 'FDF', 'FED', 'FEF',
    'FFD', 'FFF', 'FID', 'FIF',
    'LCL', 'TMB', 'AE',  'AI',
    'AT',  'DT',  'FI',  'FR',
    'LE',  'LI',  'NA',  'A'
  ]
  let sortedArray = array.sort((a, b) => {
    if (b.length === a.length) {
      return a.localeCompare(b);
    }
    return b.length - a.length;
  });
    for (let pattern of sortedArray) {
      if (input.startsWith(pattern)) {
        return input.replace(pattern, ''); 
      }
    }
    return input; 
  }
  

static getEntityFromBookingId(id){
     /**
     * booking id is generated by this way 2501FDDCMM08660006
     * 
     * leading with = year+month+shipment = 2501FDDCMM08660006 / 2501ACMM08660006 / 2501FFFCMM08660006 
     * 
     * middle is the entityId = CMM0866 or CMM08666
     * 
     * trailing is the numeric id = 0006 
     */
     if(!id) return;
     let removingYearMonth = id.slice(4)  // removing 2501
     let removingShipmentType = Utils.removeFirstMatch(removingYearMonth)
     return removingShipmentType.slice(0,removingShipmentType.length-4);
}

static isMobile() {
    const userAgent = navigator.userAgent || window.opera;
    return /android|iphone|ipad|ipod|blackberry|windows phone|opera mini/i.test(userAgent);
}

static getPropertiesForFileExtension(fileExtension){
    let property ;
   if(fileExtension){
       if(["png","jpg","jpeg","svg"].includes(fileExtension.toLowerCase())){
        property = {backgroundColor:"#2B6ED45E",icon:imageIcon}
       }else if(["xlsx","xls","csv"].includes(fileExtension.toLowerCase())){
        property = {backgroundColor:"#107C421A",icon:excelIcon}
       }else if(["pdf"].includes(fileExtension.toLowerCase())){
        property = {backgroundColor:"#FFE0E0",icon:pdfIcon}
       }else if(["doc","docx"].includes(fileExtension.toLowerCase())){
        property = {backgroundColor:"#2B6ED45E",icon:wordIcon}
       }
   }
   return property;
}


    static N(num, currency = 'INR') {
        if (!num) return ''
        if (isNaN(num)) return '0.00'
        num = Number(num)
        return num.toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            style: 'currency',
            currency: currency
        })
    }
    static N1(num, currency = 'INR') {
        if (!num) num = 0
        if (isNaN(num)) num = 0
        num = Number(num)
        return num.toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            style: 'currency',
            currency: currency
        })
    }
    static N2(num) {
        if (!num) num = 0
        if (isNaN(num)) num = 0
        num = Number(num)
        return num.toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })
    }
    static getCurrentDateString(today = new Date()) {
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = today.getFullYear();

        const ret = `${yyyy}-${mm}-${dd}`
        return ret
    }
    static getCurrentDateStringFuture(today = new Date()) {
        let nextDay = today.getDate() + 1;
        let nextMonth = today.getMonth() + 1;
        let nextYear = today.getFullYear();

        if (nextDay > new Date(nextYear, nextMonth, 0).getDate()) {
            nextDay = 1;
            nextMonth++;
        }

        if (nextMonth > 12) {
            nextDay = 1;
            nextMonth = 1;
            nextYear++;
        }

        const dd = String(nextDay).padStart(2, '0');
        const mm = String(nextMonth).padStart(2, '0');
        const yyyy = nextYear;

        const ret = `${yyyy}-${mm}-${dd}`;
        console.log(ret);
        console.log(today);
        return ret;
    }
    static getTomorrowDateString(today = new Date()) {
        const dd = String(today.getDate() + 1).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = today.getFullYear();

        const ret = `${yyyy}-${mm}-${dd}`
        return ret
    }
    static getMaxDateString(date) {
        const today = new Date(date);
        today.setDate(today.getDate() + 45)
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = today.getFullYear();

        const ret = `${yyyy}-${mm}-${dd}`
        return ret
    }
    static getDateString(datestr) {
        if (!datestr) return null;

        const separator = datestr.includes('-') ? '-' : datestr.includes('/') ? '/' : null;
        if (!separator) return null;
    
        let [day, month, year] = datestr.split(separator);
        day = day.length < 2 ? `0${day}` : day;
        month = month.length < 2 ? `0${month}` : month;
        year = year.length < 3 ? `20${year}` : year;
    
        return `${day}-${month}-${year}`;
    }
    static d2(num) {
        return String(num).padStart(2, '0')
    }
    static millis2duration(millis) {
        const d2 = Utils.d2
        let diff = millis
        let seconds = Math.round(diff / 1000)
        let minutes = Math.round(seconds / 60)
        let hours = Math.round(minutes / 60)
        let days = Math.round(hours / 24)

        seconds = seconds % 60
        minutes = minutes % 60
        hours = hours % 24
        let duration = ''
        if (days > 0) duration = days + 'd, '
        if (days > 0 || hours > 0) duration += d2(hours) + 'h:'
        duration += d2(minutes) + 'm:' + d2(seconds) + 's'
        return {
            duration, hours, minutes, seconds
        }
    }
    static getDateDifference(millis1, millis2) {
        let diff = (millis1 > millis2) ? (millis1 - millis2) : (millis2 - millis1)
        return Utils.millis2duration(diff)
    }
    static formatToDateTime(millis, withMonth = false) {
        if (!millis) return ''
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const today = new Date(millis);
        const dd = String(today.getDate()).padStart(2, '0')
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        if (withMonth) mm = months[today.getMonth()]
        const yyyy = today.getFullYear();
        let hours = String(today.getHours())
        const mins = String(today.getMinutes()).padStart(2, '0')
        let ampm = 'AM'
        if (hours > 12) {
            hours -= 12
            ampm = 'PM'
        }
        if (hours == 12) {
            ampm = 'PM'
        }

        const ret = withMonth?`${dd} ${mm},${yyyy}:${hours}.${mins} ${ampm}`:`${dd}-${mm}-${yyyy}; ${hours}:${mins} ${ampm}`
        return ret
    }

    static formatdatetimetocovert(date, time) {
        if (date.length == 0) return ""
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const today = new Date(date);
        let l = time.split(':')
        const dd = String(today.getDate()).padStart(2, '0')
        let mm = months[today.getMonth()]
        const yyyy = today.getFullYear();
        if (time.length == 0) return `${dd}-${mm}-${yyyy};`
        let hours = Number(l[0])
        const mins = String(l[1]).padStart(2, '0')
        let ampm = 'AM'
        if (hours > 12) {
            hours -= 12
            ampm = 'PM'
        }
        if (hours == 12) {
            ampm = 'PM'
        }
        hours = String(hours).padStart(2, '0')
        const ret = `${dd}-${mm}-${yyyy}; ${hours}:${mins} ${ampm}`
        return ret
    }

    static formattimetocovertampm(time) {

        let l = time.split(':')
        if (time.length == 0) return ``
        let hours = Number(l[0])
        const mins = String(l[1]).padStart(2, '0')
        let ampm = 'AM'
        if (hours > 12) {
            hours -= 12
            ampm = 'PM'
        }
        if (hours == 12) {
            ampm = 'PM'
        }
        hours = String(hours).padStart(2, '0')
        const ret = `${hours}:${mins} ${ampm}`
        return ret
    }

    static diff_hours(dt2, dt1) {
        if (dt1.length > 0) {
            let nv = new Date()
            let nv2 = new Date()
            if (dt2.length == "") {
                nv2 = new Date()
            } else {
                nv2 = new Date(dt2.split(';')[0])
                let l = dt2.split(';')[1]
                if (l.length > 0) {
                    nv2.setHours(+l.split(':')[0])
                    nv2.setMinutes(+l.split(':')[1])
                }
            }
            nv = new Date(dt1.split(';')[0])
            let l = dt1.split(';')[1]
            if (l.length > 0) {
                nv.setHours(+l.split(':')[0])
                nv.setMinutes(+l.split(':')[1])
            }
            var diff = (nv2.getTime() - nv.getTime()) / 1000;
            diff /= (60 * 60);
            return Math.abs(Math.round(diff)) + "H";
        } else {
            return ""
        }


    }

    static formatToDate(millis, withMonth = false) {
        if (!millis) return ''
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const today = new Date(millis);
        const dd = String(today.getDate()).padStart(2, '0')
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        if (withMonth) mm = months[today.getMonth()]
        const yyyy = today.getFullYear();
        let hours = String(today.getHours())
        const mins = String(today.getMinutes()).padStart(2, '0')

        const ret = `${yyyy}-${mm}-${dd}`
        return ret
    }

    static formatToDate1(millis, withMonth = false) {
        if (!millis) return ''
        const [day, month, year] = millis.split("-");
        const today = new Date(year, month - 1, day);
        const dd = String(today.getDate()).padStart(2, '0')
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = today.getFullYear();
        const now = new Date(); 
        const hours = String(now.getHours()).padStart(2, '0');
        const mins = String(now.getMinutes()).padStart(2, '0');
        const ret = `${yyyy}-${mm}-${dd}T${hours}:${mins}`
        return ret
    }
        static formatToDateTime1(dt, tm) {
        if (!dt) return ''
        let cdt = Utils.convertDateformat(dt)
        if (!tm) return cdt
        let hours = Number(tm.split(':')[0])
        let retTime = ''
        if (hours < 12) {
            retTime = `${hours}:00 AM`
        } else {
            retTime = `${hours - 12}:00 PM`
        }
        const ret = `${cdt} ${retTime}`
        return ret
    }
    static isBlank(s) {
        return !s || (s && !(s.trim().length))
    }
    static getNextFriday(date = new Date()) {
        const dateCopy = new Date(date.getTime())
        const nextFriday = new Date(
            dateCopy.setDate(
                dateCopy.getDate() + ((7 - dateCopy.getDay() + 5) % 7 || 7),
            ),
        )
        return nextFriday
    }
    static newDate(d) { // This is to get a new date from datestring in dd-mm-yyyy format
        //console.log('insidenewDate=========',d)
        if (!d || d.length < 8) return new Date()
        let dt = d
        if (dt.length > 10) dt = d.substr(0, 10)
        let p = dt.split('-')
        let d1 = dt
        if (p[2]?.length === 4) d1 = `${p[2]}-${p[1]}-${p[0]}`

        let ret = new Date(d1)
        //console.log('########newdate=', d1, ret)
        if (ret instanceof Date && !isNaN(ret)) return ret
        //console.log('########')
        //console.log('%%%%%%%$$$')
        //console.log('INSIDE newDate=',d,dt,d1,ret)
        return new Date()
    }
    static formatDate(dtless1) {
        if (!dtless1)
            return '';
        let dt = dtless1 // Utils.addDays(dtless1,1) - Temp comment, as in qa days seem correct.
        //console.log('>>>>>>>DATERECEIVED=', dtless1)
        const dd = String(dt.getDate()).padStart(2, '0');
        const mm = String(dt.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = dt.getFullYear();

        let ret = `${yyyy}-${mm}-${dd}`
        return Utils.convertDateformat(ret)
    }

    static yyyymmdd(dt) {
        const dd = String(dt.getDate()).padStart(2, '0');
        const mm = String(dt.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = dt.getFullYear();

        let ret = `${yyyy}-${mm}-${dd}`
        return ret
    }
    static ddmmyyyy(dt) {
        const dd = String(dt.getDate()).padStart(2, '0');
        const mm = String(dt.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = dt.getFullYear();
        let ret = `${dd}-${mm}-${yyyy}`
        return ret
    }
    static ddmmyyyystring(dt) {
        if (dt) {
            dt = dt.split('-')
            if (dt.length == 3) {
                return `${dt[2]}-${dt[1]}-${dt[0]}`
            } else {
                return ""
            }
        } else {
            return ""
        }

    }
    static mmddyyyy(dt) {
        const dd = String(dt.getDate()).padStart(2, '0');
        const mm = String(dt.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = dt.getFullYear();
        let ret = `${mm}-${dd}-${yyyy}`
        return ret
    }
    static setdate(day) {
        Date.prototype.addDays = function (days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }
        var date = new Date().addDays(day);
        return this.mmddyyyy(date)
    }

    static getYearDayMonthFromUnix(timestamp) {
        const numTimestamp = Number(timestamp); 
    
        if (isNaN(numTimestamp) || numTimestamp <= 0) {
            throw new Error("Invalid timestamp");
        }
    
        try {
            const date = new Date(numTimestamp);
            if (isNaN(date.getTime())) throw new Error("Invalid Date");
    
            return date.toISOString().split('T')[0];
        } catch (error) {
            console.error("Error processing timestamp:", error);
            return null;
        }
    }

    static convertToYYYYMMDD(dateStr) {
        if (!dateStr || typeof dateStr !== 'string') return ""; 
        
        const parts = dateStr.split('-');
        if (parts.length !== 3) return ""; 
        
        const [dd, mm, yyyy] = parts.map(part => part.trim());  
        if (!dd || !mm || !yyyy || isNaN(dd) || isNaN(mm) || isNaN(yyyy)) return ""; 
        
        return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
    }
    
    

    static setcrddate(crd, day) {
        Date.prototype.addDays = function (days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }
        var date = new Date(crd).addDays(day);
        return this.mmddyyyy(date)
    }

    static outGaugeContainerCheck(containerList){
        const containerTypes =["20'OT (Out-gauge)","40'OT (Out-gauge)","20'FR (Out-gauge)","40'FR (Out-gauge)"]
            const displayCargo4fcl =  containerList.some(container => 
                containerTypes.some(types=>container.containerType.includes(types))
            );
            return displayCargo4fcl
    } 

    static reformatSuffixedDate(dateString) {
        const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        if (dateString.length >= 10) {
            let t = dateString.slice(dateString.length - 10)
            let arr = t.split('-')
            if (arr.length === 3) {
                let mmm = months[Number.parseInt(arr[1])]
                const ret = dateString.slice(0, dateString.length - 10) + `${arr[0]}-${mmm}`
                return ret
            }
        }
        return dateString
    }
    static formatDateShort(dtless1) {
        let dt = Utils.formatDate(dtless1).split('-')
        return dt[0] + '-' + dt[1]
    }
    
    static validformatDateShort(d) {
        if (!d || d.length < 8) return ""
        let dt = d
        if (dt.length > 10) dt = d.substr(0, 10)
        let p = dt.split('-')
        let d1 = dt
        if (p[2]?.length === 4) d1 = `${p[2]}-${p[1]}-${p[0]}`

        let ret = new Date(d1)
        //console.log('########newdate=', d1, ret)
        if (ret instanceof Date && !isNaN(ret)){
            let dt = Utils.formatDate(ret).split('-')
            return dt[0] + '-' + dt[1]
        }else{
            return ""
        }
    }
    static convertDateformat(idate) {
        //console.log('%%%%%%%%%CONVERTING DATE FORMAT=', idate)
        if (!idate || idate.length != 10) return idate
        let parts = idate.split('-')
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        let monName = months[Number(parts[1]) - 1]
        let ret = `${parts[2]}-${monName}-${parts[0]}`
        /*if (ret === 'NaN-NaN') {
            console.log('#$%', idate, ret)
        }*/
        return ret
    }

    static labelForOutGauge({ shipmentType, shipmentScope, obj,containerDetails }) {
        let bool = false
        if (shipmentType === 'fcl') {
            if (obj.stuffingType === 'Factory' && obj.destuffingType === 'Factory') {
                const displayCargo4fcl = Utils.outGaugeContainerCheck(containerDetails)
                if (displayCargo4fcl) {
                    bool = true
                }
            }
            if (obj.stuffingType === 'Factory' && obj.destuffingType === 'Dock') {
                if (shipmentScope === 'Port-to-Port' || shipmentScope === 'Door-to-Port') {
                    const displayCargo4fcl = Utils.outGaugeContainerCheck(containerDetails)
                    if (displayCargo4fcl) {
                        bool = true
                    }
                }
            }
            if (obj.stuffingType === 'Dock' && obj.destuffingType === 'Factory' ) {
                if (shipmentScope === 'Port-to-Port' || shipmentScope === 'Port-to-Door') {
                    const displayCargo4fcl = Utils.outGaugeContainerCheck(containerDetails)
                    if (displayCargo4fcl) {
                        bool = true
                    }
                } 
            }
            if (obj.stuffingType === 'Dock' && obj.destuffingType === 'Dock') {
                if (shipmentScope === 'Port-to-Port') {
                    const displayCargo4fcl = Utils.outGaugeContainerCheck(containerDetails)
                    if (displayCargo4fcl) {
                        bool = true
                    }
                }
            }
        }
        return bool
    }

    static labelForOutGauge1(obj, containerDetails) {
        let bool = false
        if(obj!=undefined && containerDetails!=undefined){
        if (obj.shipmentType === 'fcl' || obj.shipmentType.toLowerCase().includes('fcl')) {
            if ((obj.stuffingType === 'Factory' && obj.destuffingType === 'Factory') || (obj.shipmentType.toLowerCase().includes('factory/factory'))) {
                const displayCargo4fcl = Utils.outGaugeContainerCheck(containerDetails)
                if (displayCargo4fcl) bool = true
            }
            if ((obj.stuffingType === 'Factory' && obj.destuffingType === 'Dock') || (obj.shipmentType.toLowerCase().includes('factory/dock'))) {
                if (obj.shipmentScope === 'Port-to-Port' || obj.shipmentScope === 'Door-to-Port') {
                    const displayCargo4fcl = Utils.outGaugeContainerCheck(containerDetails)
                    if (displayCargo4fcl) bool = true
                }
            }
            if ((obj.stuffingType === 'Dock' && obj.destuffingType === 'Factory') || (obj.shipmentType.toLowerCase().includes('dock/factory'))) {
                if (obj.shipmentScope === 'Port-to-Port' || obj.shipmentScope === 'Port-to-Door') {
                    const displayCargo4fcl = Utils.outGaugeContainerCheck(containerDetails)
                    if (displayCargo4fcl) bool = true
                }
            }
            if ((obj.stuffingType === 'Dock' && obj.destuffingType === 'Dock') || (obj.shipmentType.toLowerCase().includes('dock/dock'))) {
                if (obj.shipmentScope === 'Port-to-Port') {
                    const displayCargo4fcl = Utils.outGaugeContainerCheck(containerDetails)
                    if (displayCargo4fcl) bool = true
                }
            }
        }
    }
        return bool
    }

    static labelForOutGauge3({shipmentType,shipmentScope, obj}) {
        let bool = false
        if (shipmentType === 'fcl') {
            if (obj.stuffingType === 'Factory' && obj.destuffingType === 'Factory') bool = true
            if (obj.stuffingType === 'Factory' && obj.destuffingType === 'Dock') {
                if (shipmentScope === 'Port-to-Port' || shipmentScope === 'Door-to-Port') bool = true
            }
            if (obj.stuffingType === 'Dock' && obj.destuffingType === 'Factory') {
                if (shipmentScope === 'Port-to-Port' || shipmentScope === 'Port-to-Door') bool = true
            }
            if (obj.stuffingType === 'Dock' && obj.destuffingType === 'Dock') {
                if (shipmentScope === 'Port-to-Port') bool = true
            }
        }
        return bool
    }
    static displayNonStackable(shipmentType, shipmentScope) {
        const st = shipmentType
        const sc = shipmentScope
        let result
        if (st.toLowerCase().includes('fcl')) {
            if (sc === 'Port-to-Port') {
                result = false;
            } else if ((st.includes('Factory/Dock') && sc === 'Door-to-Port') || (st.includes('Dock/Factory') && sc === 'Port-to-Door')) {
                result = false
            } else {
                result = (!st.includes('Factory/Factory'))
            }
        } else {
            result = true;
        }
        return result
        // return st.toLowerCase().includes('fcl') ? (sc === 'Port-to-Port') ? false : !st.includes('Factory/Factory') : true;
        // if (st.indexOf('FCL') >= 0) {
        //     if (st.indexOf('De-stuffing') >= 0) {
        //         if (sc.endsWith('Door')) return true
        //         return false
        //     }
        //     if (sc.startsWith('Door')) return true
        //     return false
        // }
        // return true
    }
    static displayTemperatureControlled(st) {
        console.log('INSIDE displayTemperatureControlled', st)
        if (st.indexOf('FCL') >= 0 && st.indexOf('Factory') >= 0) return true
        if (st.indexOf('Air') >= 0) return true
        return false
    }
    static R(num) {
        return Math.round(num * 10000) / 10000
    }
    static R2(num) {
        return Math.round(num * 100) / 100.0
    }
    static getDays(start, end) {
        //console.log('start date=', start, 'end date=', end)
        const oneDay = 1000 * 60 * 60 * 24;
        const diffInTime = end.getTime() - start.getTime();
        const diffInDays = Math.round(diffInTime / oneDay);
        return diffInDays;
    }
    static addDays(dt, days) {
        let tempdt = new Date(dt)
        tempdt.setDate(tempdt.getDate() + days)
        //console.log('*** ADDDAYS ***', dt, '***', tempdt)
        return tempdt
    }
    static isUnloc(s) {
        let tags = s.match(/.*\(([A-Z]*)\)/)
        if (tags && tags[1].length === 5) return true
        return false
    }
    static compareDates(s1, s2) {
        if (!s1 || !s2) return 0
        if (s1.length != 10 || s2.length != 10) return 0
        let p
        p = s1.split('-')
        let d1 = p[2] + p[1] + p[0]
        p = s2.split('-')
        let d2 = p[2] + p[1] + p[0]
        return d1.localeCompare(d2)
    }

    static isEmail(email) {
        return email !== '' && email.toString().match(/^[a-zA-Z0-9_.+]+(?<!^[0-9]*)@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/)
    }

    static getStuffingAndDeStuffingType(shipmentType) {
        return shipmentType
            .toString()
            .substring(shipmentType.indexOf('(') + 1, shipmentType.indexOf(')'))
            .split('/')
            .map(type => type.trim());
    }

    static stdUnits(n, unit) {
        switch (unit) {
            case 'Cms': return n
            case 'MM': return n / 10.0
            case 'Inches': return n * 2.5
            case 'Meters': return n * 100
            case 'Feet': return n * 30.0
            case 'Kgs': return n
            case 'Tons': return n * 1000
            case 'Lbs': return n * 0.454545
            case 'CBM': return n
            case 'cu ft': return n * 0.027
            default: return n
        }
    }

    static toUnit(n, unit) {
        let ret = Utils.stdUnits(n, unit);
        return Math.round(ret * 1000) / 1000.0;
    }

    static stdkgtoUnitsconvert(nkg, unit) {
        switch (unit) {
            case 'Kgs': return nkg
            case 'Tons': return (nkg / 1000).toFixed(2)
            case 'Lbs': return (nkg * 2.2046226218).toFixed(2)
            default: return nkg
        }
    }

    static stdcmdtoUnits(n, unit) {
        switch (unit) {
            case 'Cms': return n
            case 'MM': return n * 10.0
            case 'Inches': return n / 2.5
            case 'Meters': return n / 100
            case 'Feet': return n / 30.0
            default: return n
        }
    }

    static checkAddress(address) {
        var country_list = ["afghanistan", "albania", "algeria", "andorra", "angola", "anguilla", "antigua & barbuda", "antigua and barbuda", "argentina", "armenia", "aruba", "australia", "austria", "azerbaijan", "bahamas", "bahrain", "bangladesh", "barbados", "belarus", "belgium", "belize", "benin", "bermuda", "bhutan", "bolivia", "bosnia & herzegovina", "bosnia and herzegovina", "botswana", "brazil", "british virgin islands", "brunei", "bulgaria", "burkina faso", "burundi", "cambodia", "cameroon", "cape verde", "cayman islands", "chad", "chile", "china", "colombia", "congo", "cook islands", "costa rica", "cote d ivoire", "croatia", "cruise ship", "cuba", "cyprus", "czech republic", "denmark", "djibouti", "dominica", "dominican republic", "ecuador", "egypt", "el salvador", "equatorial guinea", "estonia", "ethiopia", "falkland islands", "faroe islands", "fiji", "finland", "france", "french polynesia", "french west indies", "gabon", "gambia", "georgia", "germany", "ghana", "gibraltar", "greece", "greenland", "grenada", "guam", "guatemala", "guernsey", "guinea", "guinea bissau", "guyana", "haiti", "honduras", "hong kong", "hungary", "iceland", "india", "indonesia", "iran", "iraq", "ireland", "isle of man", "israel", "italy", "jamaica", "japan", "jersey", "jordan", "kazakhstan", "kenya", "kuwait", "kyrgyz republic", "laos", "latvia", "lebanon", "lesotho", "liberia", "libya", "liechtenstein", "lithuania", "luxembourg", "macau", "macedonia", "madagascar", "malawi", "malaysia", "maldives", "mali", "malta", "mauritania", "mauritius", "mexico", "moldova", "monaco", "mongolia", "montenegro", "montserrat", "morocco", "mozambique", "namibia", "nepal", "netherlands", "netherlands antilles", "new caledonia", "new zealand", "nicaragua", "niger", "nigeria", "norway", "oman", "pakistan", "palestine", "panama", "papua new guinea", "paraguay", "peru", "philippines", "poland", "portugal", "puerto rico", "qatar", "reunion", "romania", "russia", "rwanda", "saint pierre & miquelon", "saint pierre and miquelon", "samoa", "san marino", "satellite", "saudi arabia", "senegal", "serbia", "seychelles", "sierra leone", "singapore", "slovakia", "slovenia", "south africa", "south korea", "spain", "sri lanka", "st kitts & nevis", "st kitts and nevis", "st lucia", "st vincent", "st. lucia", "sudan", "suriname", "swaziland", "sweden", "switzerland", "syria", "taiwan", "tajikistan", "tanzania", "thailand", "timor l'este", "togo", "tonga", "trinidad & tobago", "trinidad and tobago", "tunisia", "turkey", "turkmenistan", "turks & caicos", "turks and caicos", "uganda", "ukraine", "united arab emirates", "united kingdom", "uruguay", "uzbekistan", "venezuela", "vietnam", "virgin islands (us)", "yemen", "zambia", "zimbabwe", "usa", "United States", "united states of america", "uae", "united arab emirates", "uk", "united kingdom"];
        let l = false
        let a = address.toLowerCase().split(',')
        for (let i = 0; i < a.length; i++) {
            if (country_list.indexOf(a[i].trim()) > -1) {
                l = true
                i = a.length + 1
            }
        }
        if (l == false) {
            let a = address.toLowerCase().split(' ')
            for (let i = 0; i < a.length; i++) {
                if (country_list.indexOf(a[i].trim()) > -1) {
                    l = true
                    i = a.length + 1
                }
            }
        }
        return l
    }

    static VehicleAggregation(vehicledetails){
        const vehicles = [];
        vehicledetails.forEach((vehicle)=>{
            vehicles.push(`${vehicle.numVehicles} x ${vehicle.vType}`)
        })
        return vehicles
    }

     static getNumberValue(value){
        return typeof value  === "string" ? parseInt(value) : value;
     }
     static toNum(a) {
        let n = 0;
        if (typeof a === "string") a = a.replaceAll(",", "");
        n = Number(a);
        if (isNaN(n)) n = 0;
        return n;
      }
     static AirCargoCalculation(cargodetails){
        const totalCalulation = {productType : [] ,quantity : 0,totalWeight:0,totalVolume:0,dimensions:{totalLength:0,totalWidth:0,totalHeight:0}};
        console.log("the dimensions are ",cargodetails[0])
        cargodetails.forEach(e => {
            totalCalulation.totalWeight +=  Utils.getNumberValue(e.totalWeight.value) 
            totalCalulation.totalVolume += Utils.getNumberValue(e.totalVolume.value) 
            totalCalulation.quantity += Utils.getNumberValue(e.quantity)
            totalCalulation.productType.push(e.packageType);
            totalCalulation.dimensions.totalLength += Utils.getNumberValue(e.dimensions.length);
            totalCalulation.dimensions.totalWidth += Utils.getNumberValue( e.dimensions.width);
            totalCalulation.dimensions.totalHeight += Utils.getNumberValue(e.dimensions.height);
          });   
          
       return totalCalulation;
     }

   static CalculateCargo(cargodetails,isDoor){
        const totalCalulation = {totalWeight : 0,totalVolume:0,quantity:0};
        if(isDoor){
            totalCalulation.dimensions = {totalLength:0,totalWidth:0,totalHeight:0};    
          }
        cargodetails.forEach(e => {
          totalCalulation.totalWeight += Utils.getNumberValue(e.totalWeight.value) 
          totalCalulation.totalVolume += Utils.getNumberValue(e.totalVolume.value) 
          totalCalulation.quantity += Utils.getNumberValue(e.quantity)
          if(isDoor){
            totalCalulation.dimensions.totalLength += Utils.getNumberValue(e.dimensions.length);
            totalCalulation.dimensions.totalWidth += Utils.getNumberValue( e.dimensions.width);
            totalCalulation.dimensions.totalHeight += Utils.getNumberValue(e.dimensions.height);
          }
        });   
     
        totalCalulation.totalWeight = Utils.R(
         totalCalulation.totalWeight
       );
     
       totalCalulation.totalVolume = Utils.R(
         totalCalulation.totalVolume
       );

       
     
       return totalCalulation;
     }

    static checkZipcode(zip) {
        switch (true) {
            case /(^(?:AD)*(\d{3})$)/.test(zip): return true; break;
            case /(^(\d{4})$)/.test(zip): return true; break;
            case /(^(\d{6})$)/.test(zip): return true; break;
            case /(^[A-Z]?\d{4}[A-Z]{0,3}$)/.test(zip): return true; break;
            case /(^(?:FI)*(\d{5})$)/.test(zip): return true; break;
            case /(^(?:AZ)*(\d{4})$)/.test(zip): return true; break;
            case /(^(\d{5})$)/.test(zip): return true; break;
            case /(^(?:BB)*(\d{5})$)/.test(zip): return true; break;
            case /(^(\d{3}\d?)$)/.test(zip): return true; break;
            case /(^([A-Z]{2}\d{2})$)/.test(zip): return true; break;
            case /(^([A-Z]{2}\d{4})$)/.test(zip): return true; break;
            case /(^\d{5}-\d{3}$)/.test(zip): return true; break;
            case /(^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]) ?(\d[ABCEGHJKLMNPRSTVWXYZ]\d)$)/.test(zip): return true; break;
            case /(^(\d{7})$)/.test(zip): return true; break;
            case /(^(?:CP)*(\d{5})$)/.test(zip): return true; break;
            case /(^\d{3}\s?\d{2}$)/.test(zip): return true; break;
            case /(^([a-zA-Z]\d{4}[a-zA-Z])$)/.test(zip): return true; break;
            case /(^(?:FO)*(\d{3})$)/.test(zip): return true; break;
            case /(^([Gg][Ii][Rr]\s?0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})$)/.test(zip): return true; break;
            case /(^((?:(?:[A-PR-UWYZ][A-HK-Y]\d[ABEHMNPRV-Y0-9]|[A-PR-UWYZ]\d[A-HJKPS-UW0-9])\s\d[ABD-HJLNP-UW-Z]{2})|GIR\s?0AA)$)/.test(zip): return true; break;
            case /(^((97|98)\d{3})$)/.test(zip): return true; break;
            case /(^(969\d{2})$)/.test(zip): return true; break;
            case /(^(?:HR)*(\d{5})$)/.test(zip): return true; break;
            case /(^(?:HT)*(\d{4})$)/.test(zip): return true; break;
            case /(^(D6W|[AC-FHKNPRTV-Y][0-9]{2})\s?([AC-FHKNPRTV-Y0-9]{4}))/.test(zip): return true; break;
            case /(^(\d{10})$)/.test(zip): return true; break;
            case /(^(\d{3})$)/.test(zip): return true; break;
            case /(^\d{3}-\d{4}$)/.test(zip): return true; break;
            case /(^(\d{4}(\d{4})?)$)/.test(zip): return true; break;
            case /(^(?:LT)*(\d{5})$)/.test(zip): return true; break;
            case /(^(?:L-)?\d{4}$)/.test(zip): return true; break;
            case /(^(?:LV)*(\d{4})$)/.test(zip): return true; break;
            case /(^MD-\d{4}$)/.test(zip): return true; break;
            case /(^969\d{2}(-\d{4})$)/.test(zip): return true; break;
            case /(^9695\d{1}$)/.test(zip): return true; break;
            case /(^[A-Z]{3}\s?\d{4}$)/.test(zip): return true; break;
            case /(^(\d{4}\s?[a-zA-Z]{2})$)/.test(zip): return true; break;
            case /(^\d{2}-\d{3}$)/.test(zip): return true; break;
            case /(^(97500)$)/.test(zip): return true; break;
            case /(^00[679]\d{2}(?:-\d{4})?$)/.test(zip): return true; break;
            case /(^\d{4}-\d{3}\s?[a-zA-Z]{0,25}$)/.test(zip): return true; break;
            case /(^(96940)$)/.test(zip): return true; break;
            case /(^((97|98)(3|4|7|8)\d{2})$)/.test(zip): return true; break;
            case /(^(?:SE)?\d{3}\s\d{2}$)/.test(zip): return true; break;
            case /(^(STHL1ZZ)$)/.test(zip): return true; break;
            case /(^(?:SI)*(\d{4})$)/.test(zip): return true; break;
            case /(^(4789\d)$)/.test(zip): return true; break;
            case /(^([A-Z]{2}\d{5})$)/.test(zip): return true; break;
            case /(^(?:CP)*(\d{4})$)/.test(zip): return true; break;
            case /(^([A-Z]\d{3})$)/.test(zip): return true; break;
            case /(^(TKCA 1ZZ)$)/.test(zip): return true; break;
            case /(^\d{5}(-\d{4})?$)/.test(zip): return true; break;
            case /(^008\d{2}(?:-\d{4})?$)/.test(zip): return true; break;
            case /(^(986\d{2})$)/.test(zip): return true; break;
            default: return false
        }
    }

    static getUNCodeFromLocationString(locString) {
        if (locString.indexOf('(') != -1 && locString.indexOf(')') != -1) {
            return locString
                .trim()
                .slice(locString.lastIndexOf("(") + 1, locString.length - 1);
        } else {
            return locString.trim()
        }
    }

    static isUnLoc1(locString) {
        locString = Utils.getUNCodeFromLocationString(locString);
        return locString.length === 5 && /^[A-Z0-9]+$/.test(locString)
    };

    static validunloc(a1, a2, loc, sope, key) {
        console.log("checinh");
        if (a1.includes(sope)) {
            let l = Utils.getUNCodeFromLocationString(loc)
            if (Utils.isUnLoc1(loc)) {
                Api.checkUnloc(l, (data) => {
                    if (data != -1) {
                        QuotationValidationStore.quotationValidMap[key] = true
                    } else {
                        QuotationValidationStore.quotationValidMap[key] = false
                    }
                })
            } else {
                QuotationValidationStore.quotationValidMap[key] = false
            }
        } else {
            QuotationValidationStore.quotationValidMap[key] =
                loc !== "" && (a2.includes(sope)
                    ? !Utils.isUnLoc1(loc)
                    : true);
        }
    }

    static validunloc1(loc, key) {
        if (loc == "") {
            QuotationValidationStore.quotationValidMap[key] = true
        } else {
            let l = Utils.getUNCodeFromLocationString(loc)
            if (Utils.isUnLoc1(loc)) {
                Api.checkUnloc(l, (data) => {
                    if (data != -1) {
                        QuotationValidationStore.quotationValidMap[key] = true
                    } else {
                        QuotationValidationStore.quotationValidMap[key] = false
                    }
                })
            } else {
                QuotationValidationStore.quotationValidMap[key] = false
            }
        }
    }

    static gettimer(start) {
        // get total seconds between the times
        var delta = Math.abs(Date.now() - start) / 1000;

        // calculate (and subtract) whole days
        var days = Math.floor(delta / 86400).toString();
        if (days.length == 1) days = '0' + days
        delta -= days * 86400;

        // calculate (and subtract) whole hours
        var hours = (Math.floor(delta / 3600) % 24).toString();
        if (hours.length == 1) hours = '0' + hours
        delta -= hours * 3600;

        // calculate (and subtract) whole minutes
        var minutes = (Math.floor(delta / 60) % 60).toString();
        if (minutes.length == 1) minutes = '0' + minutes
        if (start === 'NA') {
            return 'NA'
        } else {
            return `${days}D/${hours}H:${minutes}M`
        }
    }

    static debounce(func, timeout = 200) {
        return (...args) => {
            clearTimeout(timer)
            timer = setTimeout(() => { func.apply(this, args); }, timeout)
        }
    }
    static toNum(a) {
        let n = 0
        if (typeof a === 'string') a = a.replaceAll(',', '')
        n = Number(a)
        if (isNaN(n)) n = 0
        return n
    }

    static getRespectiveMember = (customer) =>{
        let l = []
        if(customer?.crossBorder?.relationshipManager || customer?.crossBorder?.customerService){
            if(customer?.crossBorder?.relationshipManager){
                l.push(customer?.crossBorder?.relationshipManager)
            }
            if(customer?.crossBorder?.customerService){
                l.push(customer?.crossBorder?.customerService)
            }
        }else if(customer?.domesticTransport?.relationshipManager || customer?.domesticTransport?.customerService){
            if(customer?.domesticTransport?.relationshipManager){
                l.push(customer?.domesticTransport?.relationshipManager)
            }
            if(customer?.domesticTransport?.customerService){
                l.push(customer?.domesticTransport?.customerService)
            }
        }else{
            l.push(`pat@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`)
        }
        return l.join(',')
    }

    static getRM = (customer) =>{
        let l = []
        if(customer?.crossBorder?.relationshipManager){
            if(customer?.crossBorder?.relationshipManager){
                l.push(customer?.crossBorder?.relationshipManager)
            }
        }else if(customer?.domesticTransport?.relationshipManager){
            if(customer?.domesticTransport?.relationshipManager){
                l.push(customer?.domesticTransport?.relationshipManager)
            }
        }else{
            l.push(`pat@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`)
        }
        return l.join(',')
    }

    static getCustomerService = (customer,createdBy) =>{
        let l = {}
        if(customer?.crossBorder?.customerService){
            if(customer?.crossBorder?.customerService){
                l['customerService'] = customer?.crossBorder?.customerService
            }
        }else if(customer?.domesticTransport?.customerService){
            if(customer?.domesticTransport?.customerService){
                l['customerService'] = customer?.domesticTransport?.customerService
            }
        }
        l['createdBy'] = createdBy
        return l
    }

    static getdeffentdate = (t1,t2) =>{
        if(t1.indexOf('T')!= -1) t1 = t1.split('T')[0]
        if(t2.indexOf('T')!= -1) t2 = t2.split('T')[0]
    const d1 = new Date(t1);
    const d2 = new Date(t2);
    const dm = d1 - d2;
    return Number((((dm / 1000)/60)/60)/24)
      }

      static calcCargoDetails = (cargoDetails,isDimension,dimensionUnit,shipmentType,k) => {
        const totals = {
            totNumPackages : 0,
            totTotalWeight : 0,
            totTotalVolume : 0,
            totChargeableWeight : 0
        }
        if(cargoDetails!=undefined){
            cargoDetails.forEach((e) => {
                let totalWeight = 0;
                let totalVolume = 0;
                let volPerPackage = 0;
                if (e.dimensions!= undefined && isDimension) {
                    let l = Utils.toUnit(parseFloat(e.dimensions?.length||0),dimensionUnit);
                    let w = Utils.toUnit(parseFloat(e.dimensions?.width||0),dimensionUnit);
                    let h = Utils.toUnit(parseFloat(e.dimensions?.height||0),dimensionUnit);
                    volPerPackage = (l * w * h) / 1000000.0;
                    volPerPackage = parseFloat(volPerPackage.toFixed(5));
                    totalWeight = parseFloat(parseInt(e.quantity||0) * parseFloat(Utils.toUnit(e.weight?.value||0,k.weight?.unit)));
                    totalVolume = ((l * w * h) / 1000000.0) * parseFloat(e.quantity||0) ;
                    if(shipmentType.toLowerCase().includes('air')){
                        totalVolume = totalVolume * 166.67;
                    }
                }else{
                    totalWeight = Utils.toUnit(parseFloat(e.totalWeight?.value||0),k.totalWeight?.unit)
                    totalVolume = Utils.toUnit(parseFloat(e.totalVolume?.value||0),k.totalVolume?.unit);
                }
                try {
                    totalVolume = parseFloat(totalVolume.toFixed(3))
                } catch(error) {
                    if(totalVolume!=undefined){
                        totalVolume = parseFloat(parseFloat(e.totalVolume).toFixed(3))
                    }
                }
        
                console.log("e.quantity . . . . . ",e.quantity)

                totals.totNumPackages += parseInt(e.quantity || 0);
                totals.totTotalWeight += parseFloat(totalWeight);
                totals.totTotalVolume += parseFloat(totalVolume);
                // cargoStore.totals.totChargeableWeight += parseFloat(e.chargeableWeight)
                totals.totTotalWeight = Utils.R(
                  totals.totTotalWeight
                );
                totals.totTotalVolume = Utils.R(
                  totals.totTotalVolume
                );
                totals.totChargeableWeight = Math.ceil(
                  Math.max(
                    totals.totTotalWeight,
                    totals.totTotalVolume
                  )
                );
              });
        }
        return totals;
    };
    
   

    static calcCargoDetailsGrand = (multidest,isDimension,dimensionUnit,shipmentType) => {
        const totals = {
            totNumPackages : 0,
            totTotalWeight : 0,
            totTotalVolume : 0,
            totChargeableWeight : 0,
        }
        if(multidest!=undefined){
            for (let i = 0; i < multidest.length; i++) {
                let cargoDetails = multidest[i]['cargoDetails']
                let k = multidest[0]['cargoDetails'][0]
                if(cargoDetails!=undefined){
                    cargoDetails.forEach((e) => {
                        let totalWeight = 0;
                        let totalVolume = 0;
                        let volPerPackage = 0;
                        if (e.dimensions!=undefined && isDimension) {
                            let l = Utils.toUnit(parseFloat(e.dimensions?.length||0),dimensionUnit);
                            let w = Utils.toUnit(parseFloat(e.dimensions?.width||0),dimensionUnit);
                            let h = Utils.toUnit(parseFloat(e.dimensions?.height||0),dimensionUnit);
                            volPerPackage = (l * w * h) / 1000000.0;
                            volPerPackage = parseFloat(volPerPackage.toFixed(5));
                            totalWeight = parseFloat(parseInt(e.quantity||0) * parseFloat(Utils.toUnit(e.weight?.value||0,k.weight?.unit)));
                            totalVolume = ((l * w * h) / 1000000.0) * parseFloat(e.quantity||0) ;
                            if(shipmentType.toLowerCase().includes('air')){
                                totalVolume = totalVolume * 166.67;
                            }
                        }else{
                            totalWeight = Utils.toUnit(parseFloat(e.totalWeight?.value||0),k.totalWeight?.unit)
                            totalVolume = Utils.toUnit(parseFloat(e.totalVolume?.value||0),k.totalVolume?.unit);
                        }
                        try {
                            totalVolume = parseFloat(totalVolume.toFixed(3))
                        } catch(error) {
                            if(totalVolume!=undefined){
                                totalVolume = parseFloat(parseFloat(e.totalVolume).toFixed(3))
                            }
                        }
                
                        totals.totNumPackages += parseInt(e.quantity||0);
                        totals.totTotalWeight += parseFloat(totalWeight);
                        totals.totTotalVolume += parseFloat(totalVolume);
                        // cargoStore.totals.totChargeableWeight += parseFloat(e.chargeableWeight)
                        totals.totTotalWeight = Utils.R(
                          totals.totTotalWeight
                        );
                        totals.totTotalVolume = Utils.R(
                          totals.totTotalVolume
                        );
                        totals.totChargeableWeight = Math.ceil(
                          Math.max(
                            totals.totTotalWeight,
                            totals.totTotalVolume
                          )
                        );
                      });
                }
            }
            
        }
        
        return totals;
    };

    static convert_calcCargoDetails = (a,shipmentScope,shipmentType,displayCargo4fcl,cargoDimensionUnit) => {
        let e = new CargoDetails()
        e.packageType = a.packageType
        e.numPackages = a.quantity
        e.wtPerPackage = Utils.toUnit(a.weight?.value, a.weight?.unit)
        e.volPerPackage = Utils.toUnit(a.volume?.value, a.volume?.unit)||0
        e.totalWeight = Utils.toUnit(a.totalWeight?.value, a.totalWeight?.unit)
        e.totalVolume = Utils.toUnit(a.totalVolume?.value, a.totalVolume?.unit)
        e.chargeableWeight = Utils.toUnit(a.chargeableWeight?.value, a.chargeableWeight?.unit)||0
        e.height = Utils.toUnit(a.dimensions?.height, cargoDimensionUnit)
        e.width = Utils.toUnit(a.dimensions?.width, cargoDimensionUnit)
        e.length = Utils.toUnit(a.dimensions?.length, cargoDimensionUnit)
        if (shipmentScope !== "Port-to-Port" || shipmentType.toLowerCase().includes('air') || shipmentType.toLowerCase().includes('fcl') || displayCargo4fcl) {
            let l = parseFloat(e.length);
            let w = parseFloat(e.width);
            let h = parseFloat(e.height);
            e.volPerPackage = (l * w * h) / 1000000.0;
            e.volPerPackage = parseFloat(e.volPerPackage.toFixed(5));
            e.totalWeight = parseFloat(parseFloat(e.numPackages) * parseFloat(e.wtPerPackage));
        if(shipmentType.toLowerCase().includes('air'))
            e.totalVolume = ((parseFloat(e.length)*parseFloat(e.width)*parseFloat(e.height)) / 1000000) * parseFloat(e.numPackages) * 166.67;
            else
                e.totalVolume = parseFloat(e.volPerPackage * e.numPackages);
        }
        try {
            e.totalVolume = parseFloat(e.totalVolume.toFixed(3))
        } catch(error) {
            if(e.totalVolume!=undefined){
                e.totalVolume = parseFloat(parseFloat(e.totalVolume).toFixed(3))
            }
        }
        return e;
    };

    static enquiry_validation_check = (rec,multidest) => {
        let err = [];
        let stype = rec.shipmentType.substr(0, 3).toLowerCase();
        let scope = rec.shipmentScope;
        let cnwt = 0
        if (stype === "fcl") {
          let con = rec.containerDetails;
          if (con.length < 1) {
            err.push("Container details cannot be empty");
            return err;
          }
          for (let i = 0; i < con.length; i++) {
            let e = con[i];
            let container = rec.containerDetails
              .filter((container) => container.containerType !== "")
              .map((ele) => ele.containerType);
            let uniqueContainer = new Set(container);
            if (container.length !== uniqueContainer.size) {
              err.push("Same ContainerType Is Not Allowed.");
              return err;
            }
            if (!e.containerType.length) {
              err.push("Containers type need to be specified");
              return err;
            }
            if (e.numContainers < 1) {
              err.push("Number of containers  need to be specified");
              return err;
            }
            if (e.wtPerContainer < 1) {
              err.push("Weight per container need to be specified");
              return err;
            }
            let maxValue =
              maxWeightPerContainerFcl[e.containerType][e.unit.toLowerCase()];
            if (parseFloat(e.wtPerContainer) > maxValue) {
              err.push(
                `Weight for ${e.containerType} container should be less than ${maxValue}.`
              );
              return err;
            }
            cnwt = cnwt+(Number(e.numContainers)*Number(Utils.toUnit(e.wtPerContainer, e.unit)))
          }
        }
        let displayCargo4fcl = false;
        {
          let e = rec;
      
          if (stype === "fcl" && e.shipmentScope === "Port-to-Door") {
            if (e.destuffingType === "Dock") displayCargo4fcl = true;
          } else if (stype === "fcl" && e.shipmentScope === "Door-to-Port") {
            if (e.stuffingType === "Dock") displayCargo4fcl = true;
          } else if (stype === "fcl" && e.shipmentScope === "Door-to-Port") {
            displayCargo4fcl = true;
            if (e.stuffingType === "Factory" && e.destuffingType === "Factory")
              displayCargo4fcl = false;
          } else if (stype === "fcl" && e.shipmentScope === "Door-to-Door") {
            displayCargo4fcl = false;
            if (e.stuffingType === "Dock" || e.destuffingType === "Dock")
              displayCargo4fcl = true;
          } else if (stype === "fcl") {
            displayCargo4fcl = Utils.outGaugeContainerCheck(
              rec.containerDetails
            );
          }
        }
        let grandtotalWeight = 0;
        let grandtotalVolume = 0;
        let z = {}
            if (multidest[0]['cargoDetails'] != undefined) {
                z = multidest[0]['cargoDetails'][0]
            }
        for (let i = 0; i < multidest.length; i++) {
            let k = ""
            if(multidest.length>1){
                k = `Destination ${i+1}:`
            }
            
            console.log("+++++++++++",multidest,multidest[i]['cargoDetails'])
            if (multidest[i]['cargoDetails'] != undefined) {
              let cargoDetails = multidest[i]['cargoDetails']
              if (stype === "lcl" || (stype === "fcl" && displayCargo4fcl)) {
                let totalWeight = 0;
                let totalVolume = 0;
                for (let i = 0; i < cargoDetails.length; i++) {
                  let cargo = cargoDetails[i];
                  if (scope === "Port-to-Port") {
                    totalWeight += parseFloat(Utils.toUnit(parseFloat(cargo?.totalWeight?.value || 0.0),z.totalWeight.unit));
                    totalVolume += parseFloat(Utils.toUnit(parseFloat(cargo?.totalVolume?.value || 0.0),z.totalVolume.unit));
                  } else {
                    totalWeight += parseFloat(cargo?.quantity || 0)*parseFloat(Utils.toUnit(parseFloat(cargo?.weight?.value || 0.0),z.weight.unit));
                    let l = Utils.toUnit(parseFloat(cargo?.dimensions?.length||0),rec.cargoDimensionUnit);
                    let w = Utils.toUnit(parseFloat(cargo?.dimensions?.width||0),rec.cargoDimensionUnit);
                    let h = Utils.toUnit(parseFloat(cargo?.dimensions?.height||0),rec.cargoDimensionUnit);
                    totalVolume += parseFloat(((l * w * h) / 1000000.0) * parseFloat(cargo?.quantity||0)) ;
                  }
                }
                grandtotalWeight += totalWeight
                grandtotalVolume += totalVolume
                let maxWeight = lclWeightForPort["totalweight"]["kgs"];
                let maxVolume = lclWeightForPort["totalvolume"]["cbm"];
                // if(stype === "lcl"){
                //     if (totalWeight > maxWeight) {
                //         err.push(
                //           `${k}Total weight per shipment can't be greater than ${maxWeight} Kgs`
                //         );
                //         i=i+multidest.length+1;break;
                //       } else if (totalVolume > maxVolume) {
                //         err.push(
                //           `${k}Total volume per shipment can't be greater than ${maxVolume} CBM`
                //         );
                //         i=i+multidest.length+1;break;
                //       }
                // }
              }
            }
          
          }
          let maxWeight = lclWeightForPort["grandtotalweight"]["kgs"];
            let maxVolume = lclWeightForPort["grandtotalvolume"]["cbm"];
            if(stype === "lcl"){
                if (grandtotalWeight > maxWeight) {
                    err.push(
                        `Grand Total weight per shipment can't be greater than ${maxWeight} Kgs`
                    );
                    } else if (grandtotalVolume > maxVolume) {
                    err.push(
                        `Grand Total volume per shipment can't be greater than ${maxVolume} CBM`
                    );
                    }
            }
            if(stype === "fcl" && displayCargo4fcl){
                console.log("++++++++++",cnwt,grandtotalWeight)
                if(cnwt<grandtotalWeight){
                    err.push(
                        `Total weight of Cargo to be delivered across multiple destinations cannot exceed the Weight of the Cargo provided in the Container Details`
                    );
                }
            }
        return err;
      };
    
    static setCargo_unit = (a,b,ar,d) =>{
        const nu = (v)=>{
            if(v!=undefined){
                return true
            }else{
                return false
            }
        }
        for (let i = 0; i < ar.length; i++) {
            if(ar[i]=='dimensions'){
                if(a[ar[i]]) a[ar[i]]['unit'] = d
            }
            if(nu(a[ar[i]]) && nu(a[ar[i]]['unit']) && nu(b[ar[i]]) && b[ar[i]]['unit']){
                a[ar[i]]['unit'] = b[ar[i]]['unit']
            }
        }
        return a
    }

    static isProductionURL = () => {
        try {
            return window.location.href.includes(`booking.${process.env.REACT_APP_ENTERPRISE_DOMAIN}`);
        } catch (error) {
            console.error(error); 
            return false; 
        }
    };
    static removeSpecialCharacters = (v,l)=>{
        v = v.replace(/[^a-zA-Z0-9]/g, '')
        if(v.length>l){
            v = v.substring(0, l)
        }
        return v
    }

    static fbaDetails=(rec)=>{
        let r = []
        if(rec.fba!=undefined && rec.fba=='Yes'){
            if(rec.multidest!=undefined && rec.multidest.length>0){
                for (let i = 0; i < rec.multidest.length; i++) {
                    r.push([{fbaID : "", purchaseOrderID : ""}])
                }
            }else{
                r = [[{fbaID : "", purchaseOrderID : ""}]]
            }
        }
        return r
    }

    static docAgeing=(e)=>{

        const currentDate = new Date().toISOString().split('T')[0];
        let currentDateObj = new Date(currentDate)
        let datestr =e["DOCUMENT_DATE"]
        let [day, month, year] = []
        if (datestr.includes("-") || datestr.includes("/")) {
            const separator = datestr.includes("-") ? "-" : "/";
            [day, month, year] = datestr.split(separator);
        
            if (year.length < 3) {
                year = `20${year}`;
            }
        
            year = parseInt(year); 
        }
        
 
        let docDate = new Date(`${year}-${month}-${day}`)
        let diff =currentDateObj - docDate   
        const diffDays = diff / (1000 * 60 * 60 * 24);
        return Math.round(diffDays-1)
    }

    static convertToDDMMYYYY(dateString) {
        try {
            if(!dateString || dateString.length===0){
                return ;
            }
            // Parse the date string to a Date object
            const parsedDate = new Date(dateString);
    
            // Check if the date is valid
            if (isNaN(parsedDate.getTime())) {
                 return;
            }
    
            // Extract day, month, and year
            const day = String(parsedDate.getDate()).padStart(2, '0');
            const month = String(parsedDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based
            const year = parsedDate.getFullYear();
    
            // Return in dd/mm/yyyy format
            return `${day}/${month}/${year}`;
        } catch (error) {
            return ;
        }
    }

    static getAirline(code){
        let name = ""
        if(code!=undefined){
            for (let i = 0; i < airlineCodes.length; i++) {
                if(airlineCodes[i]['code'] == code){
                    name = airlineCodes[i]['name']
                }
            }
        }
        return name
    }
    static getDateString(datestr) {
        if (!datestr) return null;

        const separator = datestr.includes('-') ? '-' : datestr.includes('/') ? '/' : null;
        if (!separator) return null;
    
        let [day, month, year] = datestr.split(separator);
        day = day.length < 2 ? `0${day}` : day;
        month = month.length < 2 ? `0${month}` : month;
        year = year.length < 3 ? `20${year}` : year;
    
        return `${day}-${month}-${year}`;
    }
    static fetchBookingType(bookingData) {
        let bookingEntityCountry = bookingData?.country
        let isAIRBooking = bookingData?.contract?.shipmentType?.toLowerCase().includes('air')
        let origin = this.extractCountry(isAIRBooking ? bookingData?.contract?.originAirport : bookingData?.contract?.portOfReceipt)
        let destination = this.extractCountry(bookingData?.contract?.finalPlaceOfDelivery)
        let bookingType = bookingEntityCountry === origin ? "Export" : bookingEntityCountry === destination ? "Import" : "NA"
        return bookingType
    }
    static extractPersonName(email) {
        if (!email) return ""; 
        return email.split("@")[0] 
            .replace(/\./g, " ") 
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "); 
    }
    static  creditCategory_1(amount, days) {
        if ((amount <= CREDIT_AMOUNT_LOWER_THRESHOLD || days <= CREDIT_DAYS_LOWER_THRESHOLD) && !this.creditCategory_2(amount , days ) && !this.creditCategory_3(amount , days )) {
            return true
        }
        return false

    }
    static  creditCategory_2(amount, days) {
        if (((amount > CREDIT_AMOUNT_LOWER_THRESHOLD && amount <= CREDIT_AMOUNT_UPPER_THRESHOLD) || (days > CREDIT_DAYS_LOWER_THRESHOLD && days <= CREDIT_DAYS_UPPER_THRESHOLD)) && !this.creditCategory_3(amount , days )) {
            return true
        }
        return false

    }
    static  creditCategory_3(amount, days) {
        if (amount > CREDIT_AMOUNT_UPPER_THRESHOLD || days > CREDIT_DAYS_UPPER_THRESHOLD) {
            return true
        }
        return false

    }

    static isContainerTypeOutofGuage(type){
        if(type.indexOf('Out-gauge')!=-1){
            return true
        }
        return false
    }
    static getAuthProductList = (productList) => {
        if (typeof productList === "object" && !Array.isArray(productList)) {
            return Object.keys(productList)
                .filter(filter => RoleUtils.isUserAuthorized(PERMISSIONS_NEW.FILTERS[filter.toUpperCase()]))
                .reduce((acc, filter) => {
                    acc[filter] = productList[filter];
                    return acc;
                }, {});
        } else if (Array.isArray(productList)) {
            return productList.filter(filter => RoleUtils.isUserAuthorized(PERMISSIONS_NEW.FILTERS[filter.toUpperCase()]));
        }
        return [];  
    }
    static b64toBlob(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) byteNumbers[i] = slice.charCodeAt(i);
    byteArrays.push(new Uint8Array(byteNumbers));
  }
  return new Blob(byteArrays, { type: contentType });
}

    static shouldSendCredentials = (urlString) => {
        const url = new URL(urlString);

        const pathSegments = url.pathname.split('/').filter(Boolean);

        const staticSegments = [];
        for (const seg of pathSegments) {
            if (seg.includes('@') || /\.\w/.test(seg)) break; // stop at email or filename-like
            staticSegments.push(seg);
        }

        const staticPath = staticSegments.join('/');

        const stringToCheck = `${url.hostname}/${staticPath}`;
        console.log(stringToCheck,'stringToCheck');
        
        const excludedPatterns = /agpricing|files|notify|pricing/i;
        return !excludedPatterns.test(stringToCheck);
    }

    static getChargeList=(booking)=>{
        let clist = []
        if(booking.createdFromPricing || (booking.cartingsheetId!=undefined && booking.cartingsheetId.length>0)){
            const setonaccount = (arr,key) =>{
                for (let i = 0; i < arr.length; i++) {
                    arr[i]['onaccount'] = key
                }
                return arr
            }
            const getcharge = (obj,key)=>{
                let a = []
                if(obj[key]!=undefined){
                    return obj[key]
                }
                return a
            }
            clist = JSON.parse(JSON.stringify(booking.contract.chargesList))
            clist = setonaccount(clist,'On Your Account')
            let shipperchargesList = getcharge(booking.contract,"shipperchargesList")
            shipperchargesList = setonaccount(shipperchargesList, `Shipper's Account`)
            let consigneechargesList = getcharge(booking.contract,"consigneechargesList")
            consigneechargesList = setonaccount(consigneechargesList,`Consignee's Account`)
            clist = clist.concat(shipperchargesList, consigneechargesList);
        }else{
            clist = JSON.parse(JSON.stringify(booking.contract.chargesList))
        }
        for (let i = 0; i < clist.length; i++) {
            clist[i]['id'] = i+1
        }
        return clist
    }

    
}



export const Constants = {
    quotations : "Quotations",
    contracts : "Contracts",
    createbookings : "Create Bookings",
    chooseschedule : "Choose Schedule",
    bookingsummary : "Booking Summary"

 
    
}

